import styled from "styled-components";

export const StoryXContainer = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  align-items: center;
  padding: 16px;
  overflow-x: auto;
  gap: 10px;
  position: relative;
`;

export const StoryWidget = styled.div`
  display: flex;
  position: relative;
  width: 100%;
`;
